
import {
  REQUEST_ACTIVITY,
  REQUEST_ACTIVITY_ERROR,
  RECEIVE_ACTIVITY
} from 'actions'

export default (state = {}, { type, payload }) => {
  switch (type) {
    case REQUEST_ACTIVITY:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: true,
          didRequestFail: false
        }
      }
    case REQUEST_ACTIVITY_ERROR:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: false,
          didRequestFail: true
        }
      }
    case RECEIVE_ACTIVITY:
      return {
        ...state,
        [payload.workspaceSlug]: {
          isRequesting: false,
          didRequestFail: false,
          data: payload.response
        }
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/activity.js